/* eslint-disable camelcase */
/* eslint-disable class-methods-use-this */
import { Component } from 'react';
import { Container } from 'react-bootstrap';

class PriceItPlusBrand extends Component {
  render() {
    const { data: { brands, enrollment_status } } = this.props;

    return (
      <div className="performance-details" style={{ paddingTop: 0 }}>
        <div>
          <Container fluid>
            {brands.map((brand, index) => (
              <div key={index}>
                <h2 className="no-padding">
                  {brand.name}
                  &nbsp;
                  {enrollment_status === 'Enrolled' && (<span><strong>{brand.points || 0}</strong> ignite points per product</span>) }
                </h2>
                <div className="performance-details-container">
                  <span className="text-bold product-margin-right">
                    Product
                  </span>
                  <div>
                    <div className="performance-details-row-images">
                      {brand.product_images.map((productImage, productImageIndex) => (
                        <div
                          key={productImageIndex}
                          className="performance-details-row-images-container"
                        >
                          <img src={productImage} />
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
                {brand.shelf_price && (
                  <div className="brand-margin-top">
                    <span className="text-bold brand-margin-right">
                      Shelf price
                    </span>
                    {brand.shelf_price || 0}
                  </div>
                )}
              </div>
            ))}
          </Container>
        </div>
      </div>
    );
  }
}

export default PriceItPlusBrand;
